import { render, staticRenderFns } from "./notifications-panel.vue?vue&type=template&id=5d253f0a&scoped=true"
import script from "./notifications-panel.vue?vue&type=script&lang=js"
export * from "./notifications-panel.vue?vue&type=script&lang=js"
import style0 from "./notifications-panel.vue?vue&type=style&index=0&id=5d253f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d253f0a",
  null
  
)

export default component.exports